import axios from "axios";
import { logout } from "./authUtils";

let interceptorInstalled = false;
let redirectingToLogin = false;

const AUTH_ERROR_CODES = new Set([
  "token_expired",
  "missing_token",
  "invalid_token",
  "invalid_token_format",
  "malformed_token",
  "token_verification_failed",
]);

const clearAuthState = () => {
  logout(); // This now includes CRM widget reset
};

const shouldHandleAsAuthFailure = (error) => {
  const status = error?.response?.status;
  const code = error?.response?.data?.error;
  const url = error?.config?.url || "";

  // Never treat auth endpoint 401s as session expiry - they mean wrong credentials
  if (
    url.includes("/api/auth/login") ||
    url.includes("/api/auth/customer/login") ||
    url.includes("/api/auth/register")
  ) {
    return false;
  }

  if (AUTH_ERROR_CODES.has(code)) return true;
  return status === 401;
};

const redirectToLogin = () => {
  if (redirectingToLogin) return;
  redirectingToLogin = true;

  const currentPath = `${window.location.pathname}${window.location.search}`;
  if (window.location.pathname !== "/login") {
    sessionStorage.setItem("redirectAfterLogin", currentPath);
  }

  window.location.href = "/login";
};

export const setupAxiosAuthInterceptor = () => {
  if (interceptorInstalled) return;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (shouldHandleAsAuthFailure(error)) {
        clearAuthState();
        redirectToLogin();
      }

      return Promise.reject(error);
    },
  );

  interceptorInstalled = true;
};

export default setupAxiosAuthInterceptor;
